import React, { Component } from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar'

import 'react-perfect-scrollbar/dist/css/styles.css';

import Kids from './Kids/Kids';
import AddKid from './Kids/AddKid';
import KidDetails from './Kids/KidDetails';

import Contacts from './Contacts/Contacts';
import AddContact from './Contacts/AddContact';
import ContactDetails from './Contacts/ContactDetails';

import Events from './Events/Events';
import AddEvent from './Events/AddEvent';
import EventDetails from './Events/EventDetails';

import Payments from './Payments';

import Account from './Account';

import Invites from './Invites/Invites';
import Invite from './Invites/Invite';

class Main extends Component {
    render() {
        return(
            <PerfectScrollbar>
                <Switch>
                    <Route exact path='/kids' render={(props) => <Kids {...props} myId={this.props.myId} /> } />
                    <Route path='/kids/add' render={(props) => <AddKid {...props} myId={this.props.myId} />} />
                    <Route path='/kids/update/:id' render={(props) => <AddKid {...props} myId={this.props.myId} />} />
                    <Route path='/kids/details/:id' render={(props) => <KidDetails {...props} myId={this.props.myId} />} />

                    <Route exact path='/contacts/' render={(props) => <Contacts {...props} myId={this.props.myId} />} />
                    <Route path='/contacts/add' render={(props) => <AddContact {...props} myId={this.props.myId} />} />
                    <Route path='/contacts/update/:id' render={(props) => <AddContact {...props} myId={this.props.myId} />} />
                    <Route path='/contacts/details/:id' render={(props) => <ContactDetails {...props} myId={this.props.myId} />} />

                    <Route exact path='/events/' render={(props) => <Events {...props} myId={this.props.myId} />} />
                    <Route path='/events/add' render={(props) => <AddEvent {...props} myId={this.props.myId} />} />
                    <Route path='/events/update/:id' render={(props) => <AddEvent {...props} myId={this.props.myId} />} />
                    <Route path='/events/details/:id' render={(props) => <EventDetails {...props} myId={this.props.myId} />} />
                    
                    <Route exact path='/payments/' render={(props) => <Payments {...props} myId={this.props.myId} />} />

                    <Route exact path='/invites/' render={(props) => <Invites {...props} myId={this.props.myId} />} />
                    <Route path='/invites/details' render={(props) => <Invite {...props} myId={this.props.myId} />} />

                    <Route exact path='/account/' render={(props) => <Account {...props} myId={this.props.myId} />} />

                    <Redirect exact from='/' to='/invites/' />

                    <Redirect from='/sudo/kids' to='/kids/' />
                    <Redirect from='/sudo/contacts' to='/contacts/' />
                    <Redirect from='/sudo/events' to='/events/' />
                </Switch>
            </PerfectScrollbar>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js